// extracted by mini-css-extract-plugin
export var layoutContainer = "_4m-0";
export var layoutContainerNoRounding = "_4m-6";
export var layoutContainerOpen = "_4m-5";
export var layoutContainerResizing = "_4m-1";
export var mainContent = "_4m-2";
export var resizeDivider = "_4m-3";
export var slidePanel = "_4m-4";